import { useEffect, useRef } from "react";


const useClickOutside = (containerRef, ignoredRef, callback) => {
    const callbackRef = useRef();
    callbackRef.current = callback;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                !containerRef?.current?.contains(e.target) &&
                !ignoredRef?.current?.contains(e.target) &&
                callbackRef.current
            ) {
                callbackRef.current(e);
            }
        };

        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [containerRef, ignoredRef]);
};

export default useClickOutside;